(function (window, document) {
    "use strict";

    var DNB = window.DNB;

    // İç sayfa TABANI — inner.min.js (her iç sayfada: Page / BasePage vb.).
    // Yalnızca ortak chrome: side-nav + share. Nav/Footer common.min.js'tedir.
    // Sayfaya özel init'ler: contact.js (İletişim), catalog.js (Kategoriler+Urun).
    document.addEventListener("DOMContentLoaded", function () {
        DNB.safeInit("SideMenu", function () { DNB.SideMenu.init(); });
        DNB.safeInit("Share", function () { DNB.Share.init(); });
        DNB.safeInit("About", function () { DNB.About.init(); });
        DNB.safeInit("VideoPopup", function () { DNB.VideoPopup.init(); });
        DNB.safeInit("CmsMedia", function () { DNB.CmsMedia.init(); });
        DNB.safeInit("CmsTimeline", function () { DNB.CmsTimeline.init(); });
        if (document.querySelector(".page-body__content[data-page-kompozit]")) {
            DNB.safeInit("KompozitPage", function () { DNB.KompozitPage.init(); });
        }
    });
})(window, document);